import type { FieldValues, Path, PathValue, SetValueConfig, UseFormReturn } from "react-hook-form";
import { ApiError } from "@/lib/apiClient";

export type ScannedField<T extends FieldValues> = readonly [Path<T>, string, string];

export const SCAN_KEPT_MESSAGE = "Photo attached. We kept the details you already entered.";

export function applyScan<T extends FieldValues>(
  form: UseFormReturn<T>,
  scanned: readonly ScannedField<T>[],
  { onlyEmpty, ...options }: SetValueConfig & { onlyEmpty: boolean },
): { read: ScannedField<T>[]; applied: ScannedField<T>[] } {
  const read: ScannedField<T>[] = [];
  const applied: ScannedField<T>[] = [];
  for (const entry of scanned) {
    const [name, value] = entry;
    if (!value) continue;
    read.push(entry);
    if (onlyEmpty && String(form.getValues(name) ?? "").trim() !== "") continue;
    form.setValue(name, value as PathValue<T, Path<T>>, options);
    applied.push(entry);
  }
  return { read, applied };
}

export function scanLabels<T extends FieldValues>(entries: readonly ScannedField<T>[]): string[] {
  return entries.map(([, , label]) => label);
}

export function isRetryableScanError(e: unknown): boolean {
  return !(e instanceof ApiError) || e.status === 0 || e.status >= 500;
}
